import instance from "../api/instance";
import { logout } from "./sessionActions";
import { queryString, getFilters } from "../../components/utils/functions";

import {
  GET_CLIENTS,
  CLEAR_WAIVERS,
  PENDING_CLIENTS,
  CLEAR_CLIENT_LIST,
  GET_CLIENT_BY_CIF,
  GET_CLIENT_MODULES,
  GET_CLIENT_WAIVERS,
  GET_CLIENT_ACCOUNTS,
  CLEAR_CLIENT_BY_CIF,
  CLEAR_CLIENT_ACCOUNTS,
  CLEAR_PENDING_CLIENTS,
  GET_INSTITUTIONS_PROFILE,
} from "../constants/constants";

export const getClientList = (page = 0, size = 10, filters = []) => {
  return async (dispatch) => {
    try {
      const response = await instance.get("/companies", {
        params: {
          page,
          size,
          sort: "updateDate,DESC",
          search: "status/in/TRANSITORY,ACTIVE,INACTIVE,REJECTED",
          ...filters.reduce((acc, { property, value }) => {
            acc[property] = value;
            return acc;
          }, {}),
        },
      });
      dispatch({
        type: GET_CLIENTS,
        clients: response.data.data,
      });
    } catch (err) {
      const statusCode = err.response.status;
      switch (statusCode) {
        case 401:
          dispatch(logout());
          break;
        case 500:
          dispatch(logout());
          break;
      }
    }
  };
};

export const getSearchContentClient = (page = 0, size = 10, filters) => {
  let defaults = [
    {
      property: "status",
      operator: "in",
      value: "TRANSITORY,ACTIVE,INACTIVE,REJECTED",
    },
  ];
  var searchFilters = getFilters(defaults);
  var queryFilters = [{ property: "search", value: searchFilters }, ...filters];

  return (dispatch) => {
    return instance
      .get(
        `/companies?page=${page}&size=${size}&${queryString(
          queryFilters
        )}&sort=updateDate,DESC`
      )
      .then((response) => {
        dispatch({
          type: GET_CLIENTS,
          clients: response.data.data,
        });
      })
      .catch((err) => {
        var statusCode = err.response.status;

        switch (statusCode) {
          case 401:
            dispatch(logout());
            break;
          case 500:
            dispatch(logout());
            break;
        }
      });
  };
};

export const getPendingClients = (page = 0, size = 10, filters = []) => {
  const nameRef = "institution.companyName";
  filters.unshift({ property: "pendingChange", operator: "eq", value: "true" });

  var searchFilters = getFilters(
    filters.map(({ property, value, ...rest }) => ({
      property,
      value: property === nameRef ? encodeURIComponent(value) : value,
      ...rest,
    }))
  );

  var queryFilters = [{ property: "sort", value: "updateDate,DESC" }];
  queryFilters.push({ property: "search", value: searchFilters });

  return (dispatch) => {
    return instance
      .get(`/companies?page=${page}&size=${size}&${queryString(queryFilters)}`)
      .then((response) => {
        dispatch({
          type: PENDING_CLIENTS,
          pending: response.data.data,
        });
      })
      .catch((err) => {
        var statusCode = err.response.status;

        switch (statusCode) {
          case 401:
            dispatch(logout());
            break;
          case 500:
            dispatch(logout());
            break;
        }
      });
  };
};

export const getClientByCif = (id, countryCode, relatedProfile = false) => {
  var url = relatedProfile
    ? `/companies/${id}`
    : `/customers/info/${id}/${countryCode}`;

  return (dispatch) => {
    return instance
      .get(url)
      .then((response) => {
        dispatch({
          type: GET_CLIENT_BY_CIF,
          client: response.data.data,
        });
        return response.data;
      })
      .catch((err) => {
        var statusCode = err.response.status;
        switch (statusCode) {
          case 401: // Deslogueamos porque el token es inválido
            dispatch(logout());
            break;
          default:
            return Promise.reject(err);
        }
      });
  };
};

export const getClientAccounts = (id, countryCode) => {
  return (dispatch) => {
    return instance
      .get(`/customers/accounts/${id}/${countryCode}`)
      .then((response) => {
        dispatch({
          type: GET_CLIENT_ACCOUNTS,
          account: response.data.data,
        });

        return response.data.data;
      })
      .catch((err) => {
        var statusCode = err.response.status;
        switch (statusCode) {
          case 401: // Deslogueamos porque el token es inválido
            dispatch(logout());
            break;
          case 500: // Deslogueamos porque el token es inválido
            dispatch(logout());
            break;
        }
      });
  };
};

export const getClientModules = (id) => {
  return (dispatch) => {
    return instance
      .get(`/security/modules/institution/${id}`)
      .then((response) => {
        dispatch({
          type: GET_CLIENT_MODULES,
          modulo: response.data.data,
        });

        return response.data;
      })
      .catch((err) => {
        var statusCode = err.response.status;
        switch (statusCode) {
          case 401: // Deslogueamos porque el token es inválido
            dispatch(logout());
            break;
          case 500: // Deslogueamos porque el token es inválido
            dispatch(logout());
            break;
        }
      });
  };
};

export const getInstitutionProfile = (id) => {
  return (dispatch) => {
    return instance
      .get(`/companies/${id}`)
      .then((response) => {
        dispatch({
          type: GET_INSTITUTIONS_PROFILE,
          institution: response.data.data,
        });
        return response.data;
      })
      .catch((err) => {
        var statusCode = err.response.status;
        switch (statusCode) {
          case 401: // Deslogueamos porque el token es inválido
            dispatch(logout());
            break;
          default: // Deslogueamos porque el token es inválido
            return Promise.reject(err);
        }
      });
  };
};

export const getAuthenticatedClientModules = () => {
  return (dispatch) => {
    return instance
      .get(`/security/modules/me`)
      .then((response) => {
        dispatch({
          type: GET_CLIENT_MODULES,
          modulo: response.data.data,
        });
        return response.data;
      })
      .catch((err) => {
        var statusCode = err.response.status;
        switch (statusCode) {
          case 401: // Deslogueamos porque el token es inválido
            dispatch(logout());
            break;
          case 500: // Deslogueamos porque el token es inválido
            dispatch(logout());
            break;
        }
      });
  };
};

export const clearClientsList = () => {
  return (dispatch) =>
    dispatch({
      type: CLEAR_CLIENT_LIST,
    });
};

export const clearPendingClients = () => {
  return (dispatch) =>
    dispatch({
      type: CLEAR_PENDING_CLIENTS,
    });
};

export const clearClientByCif = () => {
  return (dispatch) => {
    dispatch({ type: CLEAR_CLIENT_BY_CIF });
  };
};

export const clearClientAccounts = () => {
  return (dispatch) => {
    dispatch({ type: CLEAR_CLIENT_ACCOUNTS });
  };
};

export const getClientWaivers = (id) => {
  return (dispatch) => {
    return instance
      .get(`/companies/waiver/${id}`)
      .then((response) => {
        dispatch({
          type: GET_CLIENT_WAIVERS,
          waivers: response.data.data,
        });
      })
      .catch((err) => {
        var statusCode = err.response.status;
        switch (statusCode) {
          case 401: // Deslogueamos porque el token es inválido
            dispatch(logout());
            break;
          case 500: // Deslogueamos porque el token es inválido
            return Promise.reject(err);
        }
      });
  };
};

export const clearWaivers = () => {
  return (dispatch) => {
    dispatch({ type: CLEAR_WAIVERS });
  };
};
